import React from 'react';
import { Card, CardBody, CardHeader } from 'lunchbox';
import { SIDEBAR_STEPPER_CONSTANT } from '../../data/constant';

const SidebarStepperItems = ({ stepperItems }) =>
  (
    <div>
      {stepperItems.map((item) =>
        (
          <div key={item.stepNumber} className="flex sidebar-step__item">
            <div className="sidebar-step__numbers">
              <div className="sidebar-step__number">
                {item.stepNumber}
              </div>
              <div className="sidebar-step__line-vertical">
                <div className="line-vertical" />
              </div>
            </div>
            <div className="sidebar-step__item-text flex flex-col pb-5">
              <span className=" text-sm font-bold font-xs text-bold text-brand-primary-color">
                {item.stepTitle}
              </span>
              <span className="text-sm font-xs lp-basic--dark">
                {item.stepContent}
              </span>
            </div>
          </div>
        ))}
    </div>
  );
const SidebarStepper = () =>
  (
    <div className="sidebar__step md-max:mx-2.5">
      <Card>
        <CardHeader>
          {SIDEBAR_STEPPER_CONSTANT.headerText}
        </CardHeader>
        <CardBody>
          <SidebarStepperItems stepperItems={SIDEBAR_STEPPER_CONSTANT.stepItems} />
        </CardBody>
      </Card>
    </div>
  );
export default SidebarStepper;
